<template>
  <vs-row>
    <vs-card style="min-height: 500px">
      <vs-alert
        color="danger"
        icon-pack="feather"
        icon="icon-info"
        v-for="(errors, err) in errorMessage"
        v-bind:key="err"
      >
        <span>{{ errors }}</span>
      </vs-alert>
      <vs-alert
        color="danger"
        icon-pack="feather"
        icon="icon-info"
        v-for="error in errors.all()"
        v-bind:key="error"
      >
        <span>{{ error }}</span>
      </vs-alert>
      <div class="vx-row" style="margin-top: 20px; margin-left: 29px">
        <div class="vx-col sm:w-1/6 w-full">
          <span style="margin-top: 8px">
            <p style="font-size: 13.2px; font-weight: 600; padding-top: 6px">
              Doctor Name
            </p>
          </span>
        </div>

        <div class="vx-col sm:w-1/5">
          <select
            v-model="doctorSelected"
            class="vs-select--input myselect"
            name="Doctor"
            style="height: 38px; width: 106%"
            v-validate="'required'"
            @change="getScheduleList"
          >
            <option
              v-for="(item, index) in doctorList"
              v-bind:key="index"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </select>
          <!-- <vs-select class="selectExample" v-model="doctorSelected" @change="getScheduleList">
                    <vs-select-item :value="item.id" :text="item.name" v-for="(item,index) in doctorList" v-bind:key="index" />
                </vs-select> -->
        </div>
        <div class="vx-col w-1/4">
          <div
            :class="{ activeLoading: activeLoading }"
            :id="[`loading-material`]"
            class="vs-con-loading__container loading-example"
          ></div>
        </div>
      </div>
      <div class="vx-row" style="margin-top: 20px; margin-left: 29px">
        <div class="vx-col sm:w-1/6 w-full">
          <span style="margin-top: 8px">
            <p style="font-size: 13.2px; font-weight: 600; padding-top: 6px">
              Date Range
            </p>
          </span>
        </div>
        <div class="vx-col sm:w-1/5 w-full">
          <flat-pickr label="From" v-model="fromDate" placeholder="From Date" />
        </div>
        <div class="vx-col sm:w-1/5 w-full">
          <flat-pickr v-model="toDate" placeholder="To Date" />
        </div>
        <div class="vx-col" style="padding-left: 6px; padding-top: 6px">
          <feather-icon
            icon="SearchIcon"
            class="mr-0 cursor-pointer"
            @click="getScheduleList"
          ></feather-icon>
        </div>
      </div>
      <div class="vx-row">
        <vs-col>
          <table
            style="margin-top: 20px; margin-left: 20px; margin-right: 20px"
          >
            <thead>
              <th style="width: 9%">Date</th>

              <th style="width: 10%">Shift Time</th>
              <th style="width: 13%">LastToken Time</th>
              <th style="width: 15%">Token Duration</th>

              <th style="width: 13%">Token Available</th>
              <th style="width: 10%">Last Token</th>
              <th style="width: 8%">End Time</th>
              <th style="width: 5%">Active</th>
            </thead>
            <tr v-for="(schedule, index) in scheduleList" v-bind:key="index">
              <td>
                <vs-input
                  v-validate="'required'"
                  :name="'Date @ Row-' + (index + 1)"
                  readonly
                  v-model="schedule.date"
                  class="configclass readonly-field"
                />
              </td>

              <!--<td>
                            <vs-input v-validate="'required'" readonly v-model="schedule.tokenBookingId" class="configclass" :name="'TokenBookingId@ Row-'+(index+1)" />
                        </td>-->
              <td>
                <input
                  v-validate="'required'"
                  v-bind:readonly="attribute[index]"
                  type="time"
                  v-model="schedule.startTime"
                  class="configclass timeinput"
                  @keyup="triggerEndTime(index)"
                  @change="triggerEndTime(index)"
                  :name="'startTime @ Row-' + (index + 1)"
                />
              </td>
              <td>
                <input
                  v-validate="'required'"
                  readonly
                  type="time"
                  v-model="schedule.lastTokenTime"
                  class="configclass timeinput readonly-field"
                  @keydown.tab="insertRow(index)"
                  :name="'LastTokenTime @ Row-' + (index + 1)"
                />
              </td>
   <td>
  <div class="duration-field">
    <vs-input 
      v-validate="'required|numeric'" 
      v-bind:readonly="attribute[index]" 
      v-model="schedule.tokenDuration" 
      class="w-full configclass duration-input"
      
      @keyup="triggerEndTime(index)" 
      :name="'TokenDuration@ Row-'+(index+1)"
    />
    <span class="duration-text">minutes</span>
  </div>
</td>

              <td>
                <vs-input
                  @keyup="triggerEndTime(index)"
                  v-validate="'required|numeric'"
                  v-bind:readonly="attribute[index]"
                  v-model="schedule.maxTokenAvailable"
                  class="configclass"
                  :name="'TokenAvailable @ Row-' + (index + 1)"
                />
              </td>

              <td>
                <vs-input
                  v-validate="'required|numeric'"
                  readonly
                  v-model="schedule.lastTokenNo"
                  class="configclass readonly-field"
                  :name="'LastTokenNo @ Row-' + (index + 1)"
                />
              </td>

              <td>
                <input
                  v-validate="'required'"
                  readonly
                  type="time"
                  v-model="schedule.endTime"
                  class="configclass timeinput  readonly-time"
                  :name="'EndTime @ Row-' + (index + 1)"
                />
              </td>
              <td>
                <vs-checkbox
                  v-bind:disabled="checkboxattribute[index]"
                  class="inline-flex"
                  v-model="schedule.activeFlag"
                >
                </vs-checkbox>
              </td>
            </tr>
          </table>
        </vs-col>
      </div>
      <vs-row style="display: block">
        <vs-button
          style="
            float: right;
            margin-right: 6.5%;
            margin-bottom: 8px;
            margin-top: 8px;
          "
          id="button-with-loading"
          class="float-center vs-con-loading__container"
          @click="validateForm"
          color="success"
          type="filled"
          >Save</vs-button
        >
      </vs-row>
    </vs-card>
  </vs-row>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      //   configdateTimePicker: {
      //    allowInput : true,
      //    dateFormat:"d/m/Y",
      //     onChange: (selectedDates, dateStr, fp) => {
      //         fp.setDate(fp._input.value);
      //     }
      // },
      activeLoading: false,
      errorMessage: [],
      scheduleList: [],
      doctorList: [{ id: 0, name: "Select" }],
      doctorSelected: 0,
      checkboxattribute: [],
      attribute: [],
      weekdays: [
        {
          text: "Sunday",
          value: 1,
        },
        {
          text: "Monday",
          value: 2,
        },
        {
          text: "Tuesday",
          value: 3,
        },
        {
          text: "Wednesday",
          value: 4,
        },
        {
          text: "Thursday",
          value: 5,
        },
        {
          text: "Friday",
          value: 6,
        },
        {
          text: "Saturday",
          value: 7,
        },
      ],
      shifts: [
        {
          text: "Morning",
          value: 1,
        },
        {
          text: "Afternoon",
          value: 2,
        },
        {
          text: "Evening",
          value: 3,
        },
      ],
      fromDate: new Date().toISOString().slice(0, 10),
      toDate: new Date().toISOString().slice(0, 10),
    };
  },
  components: {
    flatPickr,
  },

  mounted() {
    this.getDoctorList();
    // console.log(this.fromDate);
  },
  methods: {
    clear() {
      this.scheduleList = [];
      this.fromDate = new Date().toISOString().slice(0, 10);
      this.toDate = new Date().toISOString().slice(0, 10);
      this.doctorSelected = 0;
    },
    openLoading() {
      this.activeLoading = true;
      this.$vs.loading();
    },
    getDoctorList() {
      var request = {
        companyId: this.$session.get("companyId"),
      };
      this.$http
        .post("getdoctorlist", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          response.data.data.forEach((value) => {
            this.doctorList.push(value);
          });
        });
    },

    getScheduleList() {
      this.errorMessage = [];
      if (this.validateSearch()) {
        var request = {
          companyId: this.$session.get("companyId"),
          id: this.doctorSelected,
          fromDate: this.fromDate,
          toDate: this.toDate,
        };
        console.log(request);
        this.openLoading();
        this.$http
          .post("getschedules", JSON.stringify(request), {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            var myresponse = response.data.data;
            myresponse.forEach((value) => {
              if (value.activeFlag == "Y") {
                value.activeFlag = true;
              } else {
                value.activeFlag = false;
              }
            });

            this.scheduleList = myresponse;
            this.setReadonly();
            this.$vs.loading.close();
          });
      }
    },

    calcEndTime: function (startTime, tokenDuration, maxTokenAvailable) {
      var Duration = tokenDuration * maxTokenAvailable;
      var hour = Math.floor(Duration / 60);
      var min = Duration % 60;
      var s = startTime.split(":");
      min = parseInt(s[1]) + parseInt(min);
      var hour_carry = 0;
      if (min >= 60) {
        min -= 60;
        hour_carry += 1;
      }
      hour = parseInt(s[0]) + parseInt(hour) + hour_carry;
      hour = hour < 10 ? "0" + hour : hour;
      min = min < 10 ? "0" + min : min;
      return hour + ":" + min;
    },
    triggerEndTime(index) {
      var data = this.scheduleList[index];
      var startTime = data.startTime;
      var tokenDuration = data.tokenDuration;
      var maxTokenAvailable = data.maxTokenAvailable;
      this.scheduleList[index].endTime = this.calcEndTime(
        startTime,
        tokenDuration,
        maxTokenAvailable
      );
      this.scheduleList[index].lastTokenTime = startTime;
    },
    setReadonly() {
      var CurrentDate = new Date();
      CurrentDate.setHours(0, 0, 0, 0);
      this.scheduleList.forEach((value, key) => {
        var date = new Date(value.date);
        date.setHours(0, 0, 0, 0);
        var lastTokenNo = value.lastTokenNo;
        if (date < CurrentDate) {
          this.attribute[key] = true;
          this.checkboxattribute[key] = true;
        } else {
          this.attribute[key] = false;
          this.checkboxattribute[key] = false;
        }
        if (lastTokenNo > 0) {
          this.attribute[key] = true;
          this.checkboxattribute[key] = true;
        }
      });
    },
    daysBetween() {
      var date1 = new Date(this.fromDate);
      var date2 = new Date(this.toDate);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var days = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (days > 30) return false;
      else return true;
    },
    validateSearch() {
      if (!this.doctorSelected) {
        this.errorMessage.push("Please Select a doctor");
      }
      if (!this.daysBetween()) {
        this.errorMessage.push(
          "Date days should not be greater than 30 days !"
        );
      }
      if (!this.isValiedDate()) {
        this.errorMessage.push("From Date should be less than To Date!");
      }
      if (this.errorMessage.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    validateForm() {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          this.errors.any();
        } else {
          this.saveSchedule();
        }
      });
    },
    buttonLoading() {
      document.getElementById("button-with-loading").disabled = true;
      this.$vs.loading({
        background: "success",
        color: "#fff",
        container: "#button-with-loading",
        scale: 0.45,
      });
    },
    saveSchedule() {
      var scheduleListCopy = JSON.parse(JSON.stringify(this.scheduleList));
      scheduleListCopy.forEach((value) => {
        if (value.activeFlag == true) {
          value.activeFlag = "Y";
        } else {
          value.activeFlag = "N";
        }
      });
      var request = {
        companyId: this.$session.get("companyId"),
        doctorId: this.doctorSelected,
        data: scheduleListCopy,
      };
      this.buttonLoading();
      this.$http
        .post("saveschedules", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          document.getElementById("button-with-loading").disabled = false;
          this.$vs.notify({
            title: "Saved Successfully",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-center",
          });
          this.clear();
        });
    },
    isValiedDate() {
      var start_Date = this.fromDate;
      var end_Date = this.toDate;
      if (Date.parse(start_Date) > Date.parse(end_Date)) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

table th,
td {
  text-align: center;
}

table thead {
  background: #eaeff3;
  line-height: 2.5rem;
}

.configclass {
  width: -webkit-fill-available;
}

.timeinput {
  padding: 7px;
  border-radius: 5px;
  border-style: groove;
  border-color: #fff8f891;
}

.cHeight {
  min-height: 550px;
}
.duration-field {
  position: relative;
  width: 100%;
}

.duration-input input {
  padding-right: 32px;   /* just enough space for min */
}

.duration-text {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #6c757d;
  pointer-events: none;
}
.readonly-field .vs-input--input {
  background-color: #f2f2f2 !important;
  color: #939ba2 !important;
  cursor: not-allowed !important;
}

.readonly-field {
  background-color: #f2f2f2 !important;
}

.readonly-time {
  background-color: #f2f2f2 !important;
  color: #939ba2 !important;
  cursor: not-allowed !important;
}
.configclass[readonly] {
  background-color: #f2f2f2 !important;
  color: #939ba2;
  cursor: not-allowed;
}
</style>
